import { betaDirectionAPI as directionAPI, thematicsAPI, usersAPI } from '@/api'
import { Config } from '@/config'
import { formateName } from '@/helpers/formateName'
import { jsonConvert } from '@/helpers/jsonConvert'
import { generateTariffCustomId } from '@/helpers/generateTariffCustomId'
import { z } from 'zod'

export const fetchSeniorSeminarians = async () => {
  //@ts-ignore
  const res = await usersAPI.getUsers({
    filter: ['[role][eq]=senior-seminarian'],
    expand: ['roles'],
    pageSize: false,
  })

  return (
    res.data.data?.map((item: ISeminarian) => ({
      label: formateName(item.name, 'F I'),
      value: item.id.toString(),
    })) ?? []
  )
}

export const fetchFolders = async (): Promise<IFolder[]> => {
  try {
    const res = await thematicsAPI.getAll()
    return res?.data?.data ?? []
  } catch (error) {
    console.error('Ошибка загрузки папок:', error)
    return []
  }
}

export const fetchColleagues = async (name: string): Promise<IColleague[]> => {
  try {
    const res = await usersAPI.getColleaguesForGroup({ name: name })
    return res?.data?.data ?? []
  } catch (error) {
    console.error('Ошибка загрузки колег:', error)
    return []
  }
}

export const fetchTeachers = async () => {
  try {
    const res = await thematicsAPI.getAll()
    return (
      res?.data?.data?.map((item: IFolder) => ({
        label: item.name,
        value: item.id.toString(),
      })) ?? []
    )
  } catch (error) {
    console.error('Ошибка загрузки папок:', error)
    return []
  }
}

export const fetchSubFolders = async (): Promise<ISubFolder[]> => {
  try {
    const res = await thematicsAPI.getAllSubFolders()
    return res?.data?.data ?? []
  } catch (error) {
    console.error('Ошибка загрузки папок:', error)
    return []
  }
}

export const fetchTariffTypes = async () => {
  const customTariffs = [
    'stream_custom_period',
    'stream_custom_days',
    'stream_custom_weeks',
  ]

  try {
    const res = await directionAPI.getTypes()
    return res?.data
      ? Object.keys(res?.data).map((key) => ({
          label: customTariffs.includes(key)
            ? res?.data['stream_custom_period']
            : res?.data[key],
          value: key,
        }))
      : []
  } catch (error) {
    console.error('Ошибка загрузки типов тарифа:', error)
    return []
  }
}

export const normalizeTariffFranchiseIds = (value: unknown): number[] => {
  const values = Array.isArray(value)
    ? value
    : value && typeof value === 'object'
      ? Object.values(value)
      : []

  return Array.from(
    new Set(
      values
        .map((item: any) => Number(item?.id ?? item?.value ?? item))
        .filter(Boolean),
    ),
  )
}

export const fetchCourseIconTemplates = async (): Promise<MediaFileData[]> => {
  try {
    const res = await directionAPI.getTemplateIcons()
    const data = res?.data?.data

    if (Array.isArray(data)) return data
    if (Array.isArray(data?.items)) return data.items

    return []
  } catch (error) {
    console.error('РћС€РёР±РєР° Р·Р°РіСЂСѓР·РєРё С€Р°Р±Р»РѕРЅРЅС‹С… РёРєРѕРЅРѕРє РєСѓСЂСЃР°:', error)
    return []
  }
}

export const fetchCourseSettings = async (id: string) => {
  if (id === 'new') return null

  try {
    const res = await directionAPI.get({
      id,
      expand: [
        'directionTariffs.directionTariffNotices',
        'directionTariffs.tariffPeriods',
        'directionTariffs.tariffWeeks',
        'directionTariffs.tariffDays',
        'seniorSeminarians',
        'mediaIcon',
      ],
    })

    const folderIds = Array.isArray(res.data.folder_ids)
      ? res.data.folder_ids.map(Number)
      : res.data.filter_id
      ? [Number(res.data.filter_id)]
      : []
    const subFolderIds = Array.isArray(res.data.sub_folder_ids)
      ? res.data.sub_folder_ids.map(Number)
      : res.data.sub_folder_id
      ? [Number(res.data.sub_folder_id)]
      : []

    return {
      ...res.data,
      folder_ids: folderIds,
      sub_folder_ids: subFolderIds,
      duration_unit: res.data.duration_unit ?? 'month',
      start_price_unit: res.data.start_price_unit ?? 'month',
      description: jsonConvert(res.data.description, 'json'),
      directionTariffs:
        res.data.directionTariffs?.map((item: ICourseTariff) => ({
          ...item,
          has_paid_cancel:
            item.type === 'group_per_lesson' ? 1 : item.has_paid_cancel,
          custom_id: item.custom_id || generateTariffCustomId(),
          franchise_ids: normalizeTariffFranchiseIds(item.franchise_ids),
          description: jsonConvert(item.description, 'json'),
          modal_footer_description: jsonConvert(
            item.modal_footer_description,
            'json',
          ),
        })) ?? [],
    }
  } catch (error) {
    console.error('Ошибка загрузки настроек курса:', error)
    return null
  }
}

export const courseDataSchema = z
  .object({
    name: z.string().min(1, 'Название не может быть пустым'),
    short_name: z.string().nullish(),
    description: z.any(),
    folder_ids: z.array(z.number()).optional(),
    sub_folder_ids: z.array(z.number()).optional(),
    start_price: z.any(),
    icon_path: z.any(),
    icon_file: z.any(),
    media_icon_id: z.any(),
  })
  .superRefine((data, ctx) => {
    // if (tiptapValueEmpty(data?.description)) {
    //   ctx.addIssue({
    //     code: z.ZodIssueCode.custom,
    //     path: ['description'],
    //     message: 'Описание должно быть заполнено!',
    //   })
    // }
    if (
      data?.start_price === null ||
      data?.start_price === undefined ||
      data?.start_price === ''
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['start_price'],
        message: 'Начальная цена должна быть указана!',
      })
    }
  })

export const courseTariffDataSchema = z
  .object({
    name: z.string().min(1, 'Название не может быть пустым для тарифа'),
    description: z.any(),
    first_price: z.any(),
    old_price: z.any(),
    type: z.any(),
    visibility_cources: z.any(),
    isAttached_groups: z.any(),
    attached_groups: z.any(),
    tariffPeriods: z.any(),
    tariffDays: z.any(),
    tariffWeeks: z.any(),
    renew_to_first_day_of_month: z.any(),
    catalog_to_first_day_of_month: z.any(),
  })
  .superRefine((data, ctx) => {
    if (!data?.type) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['type'],
        message: 'Нужно выбрать тип тарифа!',
      })
    }
    if (!data?.visibility_cources) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['visibility_cources'],
        message: 'Нужно выбрать тип открытия материалов в курсе!',
      })
    }
    // if (['stream_one_time', 'month', 'minute', 'hour', 'group_per_lesson'].includes(data?.type)) {
    //   if (!data?.first_price) {
    //     ctx.addIssue({
    //       code: z.ZodIssueCode.custom,
    //       path: ['first_price'],
    //       message: 'Должна быть указана цена курса в тарифе!',
    //     })
    //   }
    // }
    if (
      [
        'stream_custom_period',
        'stream_custom_days',
        'stream_custom_weeks',
      ]?.includes(data?.type)
    ) {
      const periods =
        data.type === 'stream_custom_period'
          ? data?.tariffPeriods ?? []
          : data.type === 'stream_custom_days'
          ? data?.tariffDays ?? []
          : data?.tariffWeeks ?? []
      if (Array.isArray(periods) && periods?.length < 1) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['tariffPeriods'],
          message: 'Должен быть указан хотя бы один период для тарифа!',
        })
      }
    }
    if (!['minute', 'hour'].includes(data?.type)) {
      if (data?.isAttached_groups && !data?.attached_groups) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['attached_groups'],
          message: 'Должна быть указана группа для распределения в тарифе!',
        })
      }
    }
  })

export interface IError {
  field: string
  error: string
}

export const saveCourseSettings = async (
  course: ICourse,
  options: { tariffsOnly?: boolean } = {},
): Promise<{
  success: boolean
  errors: IError[]
  course?: ICourse
}> => {
  try {
    const check = courseDataSchema.safeParse(course)

    if (!options.tariffsOnly && !check.success) {
      const errors = check.error.errors.map((item) => {
        return { field: item.path.toString(), error: item.message }
      })
      return { success: false, errors: errors }
    }

    for (const item of course?.directionTariffs || []) {
      if (options.tariffsOnly && item.id) continue
      const check = courseTariffDataSchema.safeParse(item)
      if (!check.success) {
        return {
          success: false,
          errors: check.error.errors.map((error) => ({
            field: error.path.toString(),
            error: error.message,
          })),
        }
      }
    }

    const formData = new FormData()

    formData.append('name', course?.name)
    formData.append(
      'short_name',
      course?.short_name?.trim() ? course.short_name : course?.name,
    )
    formData.append(
      'description',
      course?.description ? jsonConvert(course?.description) : '',
    )
    formData.append('view', course?.view?.toString())
    if (course?.seniorSeminarians?.length > 0) {
      formData.append(
        'senior_seminarian_ids',
        JSON.stringify(
          course?.seniorSeminarians?.map(({ id }) => id?.toString()),
        ),
      )
    }
    formData.append(
      'permission_add_child',
      (course?.permission_add_child === 1 ? 1 : 0)?.toString(),
    )
    formData.append(
      'flag_easily_creating',
      (course?.flag_easily_creating === 1 ? 1 : 0)?.toString(),
    )
    formData.append(
      'flag_one_block',
      (course?.flag_one_block === 1 ? 1 : 0)?.toString(),
    )
    formData.append(
      'use_promo_code',
      (course?.use_promo_code === 1 ? 1 : 0)?.toString(),
    )
    formData.append(
      'use_discount',
      (course?.use_discount === 1 ? 1 : 0)?.toString(),
    )
    // formData.append('has_demo', (course?.has_demo === 1 ? 1 : 0)?.toString())
    formData.append(
      'duration_in_months',
      course?.duration_in_months?.toString() ?? '',
    )
    formData.append('duration_unit', course?.duration_unit ?? 'month')
    const folderIds =
      course.folder_ids ?? (course.filter_id ? [course.filter_id] : [])
    const subFolderIds =
      course.sub_folder_ids ??
      (course.sub_folder_id ? [course.sub_folder_id] : [])
    formData.append('folder_ids', JSON.stringify(folderIds))
    formData.append('sub_folder_ids', JSON.stringify(subFolderIds))
    formData.append('start_price', course?.start_price)
    formData.append('start_price_unit', course?.start_price_unit ?? 'month')
    formData.append('old_price', course?.old_price ?? '')
    formData.append('u2035_parent_course_id', course?.u2035_parent_course_id ?? '')
    formData.append('u2035_level_id', course?.u2035_level_id ?? '')
    if (course.icon_file) {
      formData.append('icon_path', course.icon_file)
    }
    if (
      !course.icon_file &&
      !course.media_icon_id &&
      course.icon_path?.startsWith('/upload/icons/')
    ) {
      formData.append('icon_path', course.icon_path)
    }
    if (course.media_icon_id) {
      formData.append('media_icon_id', course.media_icon_id?.toString())
    }
    formData.append(
      'flag_allow_certificate',
      course.flag_allow_certificate?.toString(),
    )
    formData.append(
      'certificate_unlock_percentage',
      course.certificate_unlock_percentage?.toString(),
    )
    if (!!course?.directionTariffs?.length) {
      formData.append(
        'tariffs',
        jsonConvert(
          course?.directionTariffs?.map((tariff) => {
            const data: any = {}
            if (tariff.id) data.id = tariff.id
            data.name = tariff.name
            data.description = tariff.description
              ? jsonConvert(tariff.description)
              : ''
            data.gpa = tariff.gpa
            data.type = tariff.type
            data.isAttached_groups = tariff.isAttached_groups
            data.visibility_cources = tariff.visibility_cources
            data.direct_link_enabled = tariff?.direct_link_enabled ?? 0
            data.referral_program_enabled = tariff?.referral_program_enabled ? 1 : 0
            data.renew_from_payment_date = tariff?.renew_from_payment_date ?? 0
            data.renew_to_first_day_of_month =
              tariff?.renew_to_first_day_of_month ? 1 : 0
            data.catalog_to_first_day_of_month =
              tariff?.catalog_to_first_day_of_month ? 1 : 0
            data.payment_acquiring_id = tariff?.payment_acquiring_id ?? null
            data.payment_acquiring_id_secondary =
              tariff?.payment_acquiring_id_secondary ?? null
            data.any_seminarian = tariff.any_seminarian
            data.has_paid_cancel =
              tariff.type === 'group_per_lesson'
                ? 1
                : tariff.has_paid_cancel
            data.paid_cancel_student = tariff.paid_cancel_student
            data.paid_cancel_teacher = tariff.paid_cancel_teacher
            data.attached_groups =
              tariff.isAttached_groups === 1 ? tariff.attached_groups : []
            data.view = tariff?.view ?? true
            data.weekly_tariff_text_type = tariff?.weekly_tariff_text_type ?? 0
            if (tariff?.first_price) data.first_price = tariff?.first_price
            if (tariff?.old_price) data.old_price = tariff?.old_price
            if (tariff?.tariffPeriods)
              data.tariffPeriods = tariff?.tariffPeriods
            if (tariff?.tariffDays) data.tariffDays = tariff?.tariffDays
            if (tariff?.tariffWeeks) data.tariffWeeks = tariff?.tariffWeeks
            data.has_demo = tariff.has_demo
            data.demo_days = tariff?.demo_days
            data.custom_id = tariff.custom_id
            data.isCheckboxesView = [
              'stream_custom_period',
              'stream_custom_days',
              'stream_custom_weeks',
            ].includes(tariff.type)
              ? 1
              : tariff.isCheckboxesView
            data.auto_chat_settings = tariff.auto_chat_settings
            data.modal_title = tariff.modal_title
            data.modal_description = tariff.modal_description
            data.modal_footer_description = tariff.modal_footer_description
              ? jsonConvert(tariff.modal_footer_description)
              : ''
            data.modal_media_img_id = tariff.modal_media_img_id
            data.modal_media_img_placement = tariff?.modal_media_img_placement
            data.lesson_duration = tariff?.lesson_duration
            data.advantages = tariff?.advantages ?? []
            data.franchise_ids = normalizeTariffFranchiseIds(
              tariff?.franchise_ids,
            )
            data.is_custom_tariff_values = !!tariff?.is_custom_tariff_values
            data.custom_tariff_values = tariff?.custom_tariff_values ?? []

            if (tariff.directionTariffNotices?.length) {
              data.tariff_notices = []

              tariff.directionTariffNotices.map((notice) => {
                const format = {
                  delay_days: notice?.delay_days.toString(),
                  comment: notice?.comment,
                }
                data.tariff_notices.push(format)
              })
            }

            return data
          }),
        ),
      )
    } else {
      formData.append('tariffs', jsonConvert([]))
    }

    const apiCall = course?.id
      ? directionAPI.upd({ id: course?.id, data: formData })
      : directionAPI.add({ data: formData })

    const res = await apiCall
    if (res) {
      const modelError: Record<string, string[]> = res?.data?.modelError ?? {}

      return {
        success: res?.data?.status === 'success',
        errors: Object.entries(modelError).flatMap(([field, messages]) =>
          (messages ?? []).map((error) => ({ field, error })),
        ),
        course: res?.data?.data,
      }
    }
    return {
      success: false,
      errors: [],
    }
  } catch (error) {
    console.error('Ошибка сохранения курса:', error)
  }
  return { success: false, errors: [] }
}
